module.exports = __webpack_public_path__ + "static/img/6.4f32cec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/6.png
// module id = /1Tj
// module chunks = 0